import React from "react";
import { ShieldCheck } from "lucide-react";

/**
 * Confidentiality reassurance shown across the app.
 * Variants: 'card' (full sage tile), 'inline' (small line beneath forms),
 * 'footer' (compact one-liner for the site footer).
 */
export default function PrivacyNotice({ variant = "card", className = "" }) {
  if (variant === "inline") {
    return (
      <div className={`flex items-start gap-2 text-xs text-[#576056] leading-relaxed ${className}`} data-testid="privacy-notice-inline">
        <ShieldCheck size={13} className="text-[#6B7F62] flex-shrink-0 mt-0.5" strokeWidth={1.75} />
        <span>
          <span className="font-medium text-[#2D332D]">Your details are yours alone.</span>{" "}
          We never read, access, share or sell what you save. Export or delete at any time.
        </span>
      </div>
    );
  }
  if (variant === "footer") {
    return (
      <span className={`inline-flex items-center gap-1.5 text-xs text-[#8A9488] ${className}`} data-testid="privacy-notice-footer">
        <ShieldCheck size={12} strokeWidth={1.75} /> Your plan is private. We never read or share it.
      </span>
    );
  }
  // default: card
  return (
    <div className={`rounded-2xl bg-[#E9ECE8] border border-[#9EAD94]/40 p-5 md:p-6 flex items-start gap-4 ${className}`} data-testid="privacy-notice">
      <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-[#6B7F62] flex-shrink-0 mt-0.5">
        <ShieldCheck size={17} strokeWidth={1.75} />
      </div>
      <div>
        <div className="font-serif text-lg text-[#2D332D] leading-tight mb-1">Your details are yours alone.</div>
        <p className="text-sm text-[#576056] leading-relaxed">
          Everything you write here — accounts, wishes, letters — stays private. We will never read, access, share or sell what you save. You can export your plan as a PDF at any time, or delete it in a single click.
        </p>
      </div>
    </div>
  );
}
